import { alertTypes } from "shared/dist/components";

export const successStatus = {
    uploaded:
        "File have been uploaded. You can download your files on clicking the download button",
    accepted: "File accepted",
};

export const errorStatus = {
    default: "Unable to upload file",
    processing: "Error processing your proto file. Please check if you have uploaded a valid file",
    httpMoreThanOneProto: "The http service type supports only one proto file.",
    filesInsideSomeFolder: "Proto files shouldn't be in a folder",
    protoNotFound: "Proto file not found or .zip contains other files",
    maxSizeAndType: "File rejected please check the maxSize and type of file",
    tryAgain: "Please, try again",
};

export const protoAlerts = {
    pending: {
        type: alertTypes.WARNING,
        message: "Please, waiting. We're processing your proto file",
    },
    failed: {
        type: alertTypes.ERROR,
        message: "Error processing your proto file. Please check if you have uploaded a valid file",
    },
    succeeded: {
        type: alertTypes.SUCCESS,
        message:
            "File have been uploaded. You can download your files on clicking the download button",
    },
};

export const protoStatusTypes = {
    NOT_FIND: "notFind", // if file type is undefined in media
    PENDING: "pending",
    FAILED: "failed",
    SUCCEEDED: "succeeded",
};
